import React from 'react';
import clsx from 'clsx';

type Props = {
  className?: string;
};

export default function PulsatingDots({ className }: Props) {
  return (
    <span className={clsx('inline-flex items-center gap-1', className)} aria-hidden="true">
      <span
        className="h-2 w-2 rounded-full bg-blue-600 animate-pulse"
        style={{
          animationDelay: '0s',
          animationDuration: '2s',
        }}
      />
    </span>
  );
}
